<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">

		<UserAddNew :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
		<vs-card>
			<b-row class="justify-content-md-start" v-if="!isMobile()">
				<b-col cols="3">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')" @keyup.enter="filterStockList"
							size="sm" />
					</b-form-group>
				</b-col>
				<b-col cols="12" md="auto" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStockList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>

			</b-row>
			<b-row class="justify-content-md-start" v-else>
				<b-col cols="6">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')" @keyup.enter="filterStockList"
							size="sm" />
					</b-form-group>
				</b-col>
				<b-col cols="2" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStockList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>

			</b-row>
		</vs-card>

		<b-row>
			<b-col>
				<vs-card>
					<form>
						<b-row style="margin-top:8px" v-if="ROLE != 'Company'">
							<b-col cols="4" align-self="center">
								<b-form-group class="label-cs" :label="'* ' + $t('Company') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-model="company" :options="company_choices" size="small" label="name"
									autocomplete ref="selectElement" name="company" v-validate="'required'">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('company')">{{
									errors.first('company')
								}}</span>
							</b-col>
						</b-row>

						<b-row style="margin-top:8px">
							<b-col cols="4" align-self="center">
								<b-form-group  class="label-cs"  :label="'* ' + $t('Role') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<v-select color="danger" v-model="role" :options="role_choices" size="small" label="name" autocomplete
									ref="selectElement" name="role" v-validate="'required'">
								</v-select>
								<span class="text-danger text-sm" v-show="errors.has('role')">{{
									errors.first('role')
								}}</span>
							</b-col>
						</b-row>


						<b-row style="margin-top:8px">
							<b-col cols="4" align-self="center">
								<b-form-group  class="label-cs"  :label="'* ' + $t('UserName') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<vs-input size="small" v-model="userName" type="text" class="w-full" name="userName"
									v-validate="'required'" />

								<span class="text-danger text-sm" v-show="errors.has('userName')">{{
									errors.first('userName')
								}}</span>
							</b-col>
						</b-row>

						<b-row style="margin-top:8px">
							<b-col cols="4" align-self="center">
								<b-form-group  class="label-cs"  :label="'* ' + $t('Password') + ' :'" label-for="h-first-name">
								</b-form-group>
							</b-col>
							<b-col cols="8">
								<vs-input size="small" v-model="userPass" type="text" class="w-full" name="userPass"
									v-validate="'required'" />

								<span class="text-danger text-sm" v-show="errors.has('userPass')">{{
									errors.first('userPass')
								}}</span>
							</b-col>
						</b-row>



						<vs-divider />
						<b-row>
							<div class="flex justify-between mb-2">
								<vs-button id="button-with-loading" class="w-full vs-con-loading__container" @click="addUser"
									style="height: 50px; border-radius: 5px;">
									{{ $t('UserCreate') }}</vs-button>

							</div>
						</b-row>
						<b-row>
							<div class="flex justify-between mb-2">
								<vs-button @click="clearFields" id="button-with-loading" color="danger"
									class="w-full vs-con-loading__container" style="height: 50px; border-radius: 5px;">
									{{ $t('Clear') }}</vs-button>
							</div>
						</b-row>
					</form>
				</vs-card>
			</b-col>
			<b-col lg="8" sm="12">
				<vs-card>
					<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
						:columnDefs="userColumns" :defaultColDef="defaultColDef" :rowData="userList" rowSelection="multiple"
						colResizeDefault="shift" :animateRows="true" :pagination="true" @grid-ready="onGridReady"
						:suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true" :localeText="localeText">
					</ag-grid-vue>
				</vs-card>
			</b-col>

		</b-row>

	</div>
</template>
  
<script>
import { Validator } from "vee-validate";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData"
import { Icon } from "@iconify/vue2";
import UserAddNew from './UserAddNew.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import SuccessBtn from '../../components/vx-button/SuccessBtn.vue'
import { isMobile } from "mobile-device-detect";
import vSelect from "vue-select";
import { uuid } from "vue-uuid";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue"
export default {
	components: {
		detailBtnCellRenderer, vSelect, AgGridVue, UserAddNew, SuccessBtn, Icon, uuid
	},
	data() {
		return {
			userId: "",
			role: "",
			role_choices: [],

			userPass: "",
			userName: "",
			company: "",
			company_choices: [],
			ROLE: this.$store.state.AppActiveUser.ROLE,
			defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
			userList: this.users,
			userColumns: null,
			searchedVal: "",
			isMobile: function () {
				return isMobile;
			},
			selected: [],
			// products: [],
			itemsPerPage: 4,
			isMounted: false,

			// Data Sidebar
			addNewDataSidebar: false,
			sidebarData: {}
		}
	},
	computed: {
		roleList: {
			get() {

				return this.$store.state.role.Role
			},
			set(val) {
				if (!val) {
				}
			}
		},
		companyList: {
			get() {
				return this.$store.state.customer.Customer
			},
			set(val) {
				if (!val) {
				}
			}
		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
		users: {
			get() {
				return this.$store.state.user.Users
			},
			set(val) {
				if (!val) {
				}
			}

		},
	},
	methods: {
		removeUser(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("user/deleteUser", data.UserId)
				.then(response => {
					console.log(response)
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							console.log(this.users)
							this.deleteWarningPromptValid = false;
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data[0].value.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});

		},
		getRoleList() {
			this.roleList.forEach((val, index) => {
				this.role_choices.push({ value: val.RoleId, name: val.RoleName })
			});
		},
		getCompanyList() {
			console.log(this.companyList)
			this.companyList.forEach((val, index) => {
				this.company_choices.push({ value: val.CompanyId, name: val.CompanyNo })
			});
		},
		addUser() {
			const vs = this.$vs;
			this.$validator.validateAll().then(result => {
				console.log(result)
				if (result) {
					var createdId = uuid.v4();

					const obj = {
						"userId": this.userId != "" ? this.userId : createdId,
						"userName": this.userName,
						"userPass": this.userPass,
						"companyCode": this.company.name,
						"roleName": this.role.name
					}
					this.$store.dispatch('user/addUser', obj).then(response => {
						console.log(response)
						if (response.status == 200) {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							console.log(this.$store.state.user.Users)
							this.clearFields();
							this.$emit('closeSidebar')
							this.initValues()
						} else {
							vs.notify({
								text: response.data.message.toString(),
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}
					})
						.catch(error => {
							return new Promise((resolve, reject) => {
								resolve(false);
							});
						});
				}
				else {
					vs.notify({
						text: this.$t('Validate'),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center"
					});
				}
			})
		},
		clearFields() {
			this.userId = "";
			this.userName = "";
			this.userPass = "";
			this.company = "";
			this.role = "";
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			var defaultSortModel = [
				{ colId: 'UserName', sort: 'asc', sortIndex: 0 },
			];
			params.columnApi.applyColumnState({ state: defaultSortModel });

		},
		addNewData() {
			this.sidebarData = {}
			this.toggleDataSidebar(true)
		},
		deleteData(id) {
			this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
		},
		editData(data) {
			// this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
			this.sidebarData = data
			this.toggleDataSidebar(true)
		},
		getOrderStatusColor(status) {
			if (status === 'on_hold') return 'warning'
			if (status === 'delivered') return 'success'
			if (status === 'canceled') return 'danger'
			return 'primary'
		},
		getPopularityColor(num) {
			if (num > 90) return 'success'
			if (num > 70) return 'primary'
			if (num >= 50) return 'warning'
			if (num < 50) return 'danger'
			return 'primary'
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val
		}
	},
	created() {
		this.getCompanyList();
		this.getRoleList();
		this.userList = this.users
		if (!moduleDataList.isRegistered) {
			this.$store.registerModule('dataList', moduleDataList)
			moduleDataList.isRegistered = true
		}
		this.$store.dispatch('dataList/fetchDataListItems')

		const dict = {
			custom: {

				company: {
					required: this.$t('customerRequired'),
					alpha: this.$t('customerRequired')
				},
				role: {
					required: this.$t('RoleRequired'),
					alpha: this.$t('RoleRequired'),
				},
				userName: {
					required: this.$t('UserNameRequired'),
					alpha: this.$t('UserNameRequired')
				}, userPass: {
					required: this.$t('PasswordRequired'),
					alpha: this.$t('PasswordRequired')
				},

			}
		};
		Validator.localize("en", dict);
	},
	mounted() {
		//tables global olarak tanımlanıyor
		this.$root.$on("addNewData", () => {
			this.addNewData();
		});
		this.$root.$on("removeUser", (data) => {
			this.removeUser(data);
		});
		this.isMounted = true

	},
	beforeDestroy() {
		this.$root.$off("addNewData");
		this.$root.$off("removeUser");

	},
	beforeMount() {
		this.userColumns = [
			{
				width: 75,
				pinned: "left",
				cellRendererFramework: "detailBtnCellRenderer",
				cellRendererParams: {
					detailMethods: "removeUser",
					iconDetail: "ep:remove-filled",
					iconColor: "#fe6d73"
				},
			},
			{
				headerName: this.$t("CompanyNo"),
				field: "CompanyCode",
				sortable: true,
				filter: "agSetColumnFilter",
			},

			{
				headerName: this.$t("RoleName"),
				field: "RoleName",
				sortable: true,
				filter: "agSetColumnFilter",
			},

			{
				headerName: this.$t("UserName"),
				field: "UserName",
				sortable: true,
				filter: "agSetColumnFilter",
			},
			{
				headerName: this.$t("Password"),
				field: "UserPass",
				sortable: true,
				filter: "agSetColumnFilter",
			},
		];
	}
}
</script>
  
 
<style lang="scss">
.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 230px);

	&:not(.ps) {
		overflow-y: auto;
	}
}

.label-cs {
	color: black;
	font-size: small;
}

#data-list-list-view {
	.vs-con-table {

		/*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			>span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					&+i {
						left: 1rem;
					}

					&:focus+i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

				td {
					padding: 20px;

					&:first-child {
						border-top-left-radius: .5rem;
						border-bottom-left-radius: .5rem;
					}

					&:last-child {
						border-top-right-radius: .5rem;
						border-bottom-right-radius: .5rem;
					}
				}

				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
  